import { CommonModule, NgClass } from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBarModule, MatSnackBar} from '@angular/material/snack-bar';
import {NotificationService} from '@modules/notification/services/notification.service';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import {NotificationComponent} from './components/notification/notification.component';
import { TranslationPipe } from '@pipes/translation.pipe';

export const NotificationServiceFactory = (snackBar: MatSnackBar): NotificationService  => new NotificationService(snackBar);

@NgModule({
  declarations: [NotificationComponent],
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    TranslationPipe,
  ],
})
export class NotificationModule {
  static forRoot(): ModuleWithProviders<NotificationModule> {
    return {
      ngModule: NotificationModule,
      providers: [
        {
          provide: NotificationService,
          useFactory: NotificationServiceFactory,
          deps: [MatSnackBar],
        }
      ],
    };
  }
}
